import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	className: "caret-icon",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M4.75,7.29c-.25-.33-.02-.81,.4-.81h7.72c.42,0,.65,.48,.4,.81l-.15,.19-3.75,3.88c-.2,.2-.52,.2-.72,0l-3.75-3.88-.15-.19Z"
	})
});
export default SvgCaretIcon;
